import { Link } from 'react-router-dom';
import { categories, ingredients } from '../../resource/Products';


function Categories() {
  return (
    <div className="categories__container">
      <div className="categories__wrapper column">
        <div className="categories__content-part column">
          <div className="categories__content-title">
            <h1>용도별로 보기</h1>
          </div>
          <div className="categories__content-box">
            <ol className="categories__content-list">
              { categories.map(category => (
                <Link to={`/products/category/${category.path}`}>
                  <li key={category.id} className="list__item-nobullet categories__content-item row">
                    <span className="list__item-name">{category.name}</span>
                    <span className="list__item-amount">{category.amount}</span>
                  </li>
                </Link>
              ))}
            </ol>
          </div>
        </div>
        <div className="categories__content-part column">
          <div className="categories__content-title">
            <h1>성분별로 보기</h1>
          </div>
          <div className="categories__content-box">
            <ol className="categories__content-list">
            { ingredients.map(ingredient => (
                <Link to={`/products/ingredient/${ingredient.path}`}>
                  <li key={ingredient.id} className="list__item-nobullet categories__content-item">{ingredient.name}</li>
                </Link>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Categories;